export class LiveFeedPreview {
  constructor(
    public id: string,
    public clientId: string,
    public brodcasterId: string,
    public availabilityZoneUrls: {
      [id: string]: AvailabilityzoneUrl;
    },
  ) {}
}

export class AvailabilityzoneUrl {
  id: number;
  displayName: string;
  url: string;
  constructor() {}
}
